<template>
    <el-row style="margin-top: 100px;">
        <el-col :sm="24" :lg="6">
            <el-result icon="success" title="扫码成功" subTitle="请等待web页面跳转或提示">
            </el-result>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        name: "success"
    }
</script>

<style scoped>

</style>
